import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import Grabbable from '../misc/GrabbableObject'
import Label from '../misc/Label'
import Icon from '../misc/Icon'

const gltfLoader = new GLTFLoader()

export default class PolesScene extends THREE.Object3D {
    constructor(controls) {
        super()
        this.controls = controls
        this.create()
    }

    async create() {
        await this.loadPoles()
        await this.loadIcons()
    }

    async loadPoles() {
        const trashPole = await gltfLoader.loadAsync('https://pivotal-5g-webxr.s3.amazonaws.com/assets/TrashPole.glb')
        const trashModel = trashPole.scene
        trashModel.traverse(function (child) {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        const poleGltf = await gltfLoader.loadAsync('https://pivotal-5g-webxr.s3.amazonaws.com/assets/LightPole.glb')
        const lightModel = poleGltf.scene
        lightModel.traverse(function (child) {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        const bikeStand = await gltfLoader.loadAsync('https://pivotal-5g-webxr.s3.amazonaws.com/assets/BikeStand.glb')
        const bikeModel = bikeStand.scene
        bikeModel.traverse(function (child) {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        this.add(lightModel)
        this.add(trashModel)
        this.add(bikeModel)


        const miniTrash = this.loadMini(trashModel, '#wasteBin')
        const miniLight = this.loadMini(lightModel, '#streetLight')
        const miniBike = this.loadMini(bikeModel, '#bikeStand')

        trashModel.position.set(-5, 0, -5)
        lightModel.position.set(0, 0, -5)
        bikeModel.position.set(5, 0, -5)

        miniTrash.position.set(-.5, 0.5, -.5)
        miniLight.position.set(0, 0.5, -.5)
        miniBike.position.set(.5, 0.5, -.5)

        this.miniTrash = miniTrash
        this.miniBike = miniBike
        this.miniLight = miniLight

        this.loadTable()
    }

    async loadIcons() {
        // const rewindButton = new Icon(this.controls, { src: 'https://pivotal-5g-webxr.s3.amazonaws.com/assets/Rewind.png', color: 'white', height: 0.35, width: 0.35 })
        // this.add(rewindButton)

        // rewindButton.position.set(0.1, 0.35, -0.15)
        // rewindButton.addEventListener('click', () => {
        //     console.log('rewind')
        //     this.reset()
        // })
    }

    async loadTable() {
        const geo = new THREE.BoxGeometry(2, 0.5, 0.65)
        const material = new THREE.MeshStandardMaterial({
            color: 0x6c6c6c,
        });
        const cube = new THREE.Mesh(geo, material)
        cube.receiveShadow = true
        this.add(cube)
        cube.position.set(0, 0.25, -0.5)
    }

    reset() {
        const { miniBike, miniLight, miniTrash } = this

        this.attach(miniBike)
        this.attach(miniLight)
        this.attach(miniTrash)

        miniBike.children[0].position.set(0, 0, 0)
        miniLight.children[0].position.set(0, 0, 0)
        miniTrash.children[0].position.set(0, 0, 0)

        miniTrash.position.set(-.5, 0.5, -.5)
        miniLight.position.set(0, 0.5, -.5)
        miniBike.position.set(.5, 0.5, -.5)

        miniTrash.rotation.set(0, 0, 0)
        miniLight.rotation.set(0, 0, 0)
        miniBike.rotation.set(0, 0, 0)
    }

    loadMini(object, selector) {

        const label = new Label(selector, 0.125 * 10, 0.25 * 10)
        label.position.set(0, 5, 1)
        object.add(label)

        const mini = object.clone()
        const miniLabel = new Label(selector, 0.125 * 10, 0.25 * 10)
        miniLabel.position.set(0, 5, 1)
        mini.add(miniLabel)
        const miniScale = 0.1

        const grabbable = new Grabbable(this.controls)
        this.controls.addEventListener('selectEnd', () => {
            this.reset()
        })
        mini.scale.set(miniScale, miniScale, miniScale)
        grabbable.add(mini)
        this.add(grabbable)

        return grabbable
    }
}
